export default [
  {
    path: '/yzxml',
    name: 'yzxml',
    component: () => import(/* webpackChunkName: "yzxml" */ './Yzxml')
  }
]
